import React, { useEffect } from "react";
import { connect } from "react-redux";
import EVPDashboardContainer from "./EVPDashboardContainer";
import BrokerDashboardContainer from "./BrokerDashboardContainer";
import operations from "./ducks/operations";
import includes from "lodash/includes";
import ReviewPropertiesContainer from "../property/ReviewPropertiesContainer";
import ReactGA from "react-ga4";

const DashboardContainer = (props) => {
    const { authenticatedUserProfile, userProfile } = props;

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/dashboard", title: "Dashboard" });
    }, [userProfile.user]);

    const isAuthorized =
        authenticatedUserProfile.role === "dataEntry" ||
        authenticatedUserProfile.role === "dataAdmin" ||
        authenticatedUserProfile.user === userProfile.user;

    const isBrokerRole = includes(["broker", "portlandBrokerAdmin", "arizonaBrokerAdmin"], userProfile.role);
    const isEVPRole = includes(["evp"], userProfile.role);

    if (isAuthorized && isBrokerRole) {
        return <BrokerDashboardContainer {...props} />;
    }

    if (isAuthorized && isEVPRole) {
        return <EVPDashboardContainer {...props} />;
    }

    return <ReviewPropertiesContainer {...props} />;
};

const mapStateToProps = (state) => ({
    userProfile: state.authReducer.userProfile,
    authenticatedUserProfile: state.authReducer.authenticatedUserProfile,
    loading: state.utilsReducer.loading,
    sort: state.dashboardReducer.sort,
});

const mapDispatchToProps = (dispatch) => ({
    handleSort: (component, column) => {
        dispatch(operations.handleSort(component, column));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);
